export enum Permission {
  DENY = -1,
  INHERIT = 0,
  VIEW_ONLY = 1,
  APPROVE = 3,
  EDIT = 5,
  GRANT = 7,
  ADMIN = 11,
}
